// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__ixTcg","itemTitle":"ClientEmergencyInfo_itemTitle__2lP4v","itemText":"ClientEmergencyInfo_itemText__jiSc2"};